import React, { useState } from 'react'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { Box } from '@material-ui/core'

export const MenuComponent = ({ options, styles = {} }) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)
    const handleClick = event => setAnchorEl(event.currentTarget)
    const handleClose = () => setAnchorEl(null)

    return (
        <Box>
            <IconButton onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                style={styles}
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: styles
                }}
            >
                {options.map(
                    (option, idx) =>
                        !option.hide && (
                            <MenuItem
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10
                                }}
                                key={idx}
                                onClick={() => {
                                    option.onClick()
                                    handleClose()
                                }}
                            >
                                {option.content}
                            </MenuItem>
                        )
                )}
            </Menu>
        </Box>
    )
}
